import axios from '../../utils/AxiosUtils';
import i18n from '../../i18next';

import { LOADING, BATCH_RESEND_SUCCESS } from '../types';
import MessageUtils from "../../utils/MessageUtils";

export const batchResendOrders = (params) => {
    return (dispatch) => {

        const url = `/system/orders/batch-resend${params}`;

        dispatch({ type: LOADING, payload: true });

        axios().put(url, {})
            .then(res => batchResendSuccess(res.data.data, dispatch))
            .catch(err => MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:posSettings.somethingWrong')));
    }
}

const batchResendSuccess = (resData, dispatch) => {
    dispatch({ type: LOADING, payload: false });

    dispatch({ type: BATCH_RESEND_SUCCESS, payload: resData });
}


// WEBPACK FOOTER //
// ./src/actions/systemControl/ResendOrdersActions.js